import { CommonSharedByType, mapCommonSharedByType } from "../../Share/CommonSharedByType";
import { mapShareContactTypes, ShareContactTypes } from "../ShareContactTypes";
import { ClientAccountType, mapClientAccountTypes, ClientAccountCompany, mapClientAccountCompanies } from "./ClientAccountType";

export interface ClientAccountProjectType {
    project_id?: number;
    job_number?: string;
    project_type?: 'CP' | 'DP';
    description?: string;
    status?: 'Current' | 'Ongoing' | 'Completed';
    address?: string;
    post_code?: string;
    is_client_account_project_list?: boolean;
    data?: ClientAccountType[];
    company_list?: ClientAccountCompany[];
    is_own_project?: boolean;
    contact?: ShareContactTypes[];
    share_list?: ShareContactTypes[];
    shared_by: CommonSharedByType | null;
    can_edit?: boolean;

}

// to single object maping
export const mapClientProjectType = (data: any): ClientAccountProjectType => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    
    const input: ClientAccountProjectType = {
        project_id: data.project_id,
        job_number: data.job_number,
        project_type: data.project_type,
        description: data.description,
        status: data.status,
        address: data.address,
        post_code: data.post_code,
        is_client_account_project_list: data.is_client_account_project_list,
        data: mapClientAccountTypes(data.data),
        company_list: mapClientAccountCompanies(data.company_list),
        is_own_project: data.is_own_project,
        contact: mapShareContactTypes(data.contact),
        share_list: mapShareContactTypes(data.share_list),
        shared_by: data.shared_by ? mapCommonSharedByType(data.shared_by) : null,
        can_edit: data.can_edit,
    }

    return input;
}

// maping list objects
export const mapClientProjectTypes = (data: any[]): ClientAccountProjectType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapClientProjectType);
}